import { setToast } from '@/entities/toast'
import { widgetWindowsSelector } from '@/entities/widgetWindows'
import { OperationsMapWidgetWindow } from '@/entities/widgetWindows/models/WidgetWindow'
import { updateWidgetWindow } from '@/entities/widgetWindows/widgetWindowsSlice'
import { TOOL_WIDGETS } from '@/shared/components/Mosaic/models/widgetType'
import { ThunkApiContext } from '@/shared/store'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

export const showShiftOnMap = createAsyncThunk<void, { shiftId: EntityId }, ThunkApiContext>(
  'operations/showShiftOnMap',
  async ({ shiftId }, { getState, dispatch }) => {
    const state = getState()
    const activeWidgetWindowId = state.widgetWindows.activeWidgetWindowId
    const mapWidgetWindows = widgetWindowsSelector.selectAll(state)
      .filter((widget) => widget.widgetType === TOOL_WIDGETS.Map)

    let selectedMapWidgetWindow = mapWidgetWindows.find((widget) => widget.id === activeWidgetWindowId)

    if (!selectedMapWidgetWindow && mapWidgetWindows.length > 0) {
      selectedMapWidgetWindow = mapWidgetWindows[0]
    }

    if (!selectedMapWidgetWindow) {
      dispatch(setToast({
        open: true,
        severity: 'error',
        title: 'No map widget presented in the layout',
        content: 'Drag and drop the map widget onto the layout before showing the shift on the map',
      }))

      return
    }

    const existingShiftIds = (selectedMapWidgetWindow as OperationsMapWidgetWindow).shiftIds || []

    if (existingShiftIds.includes(shiftId)) {
      return
    }

    // Add shift to map widget window
    dispatch(updateWidgetWindow({
      id: selectedMapWidgetWindow.id,
      changes: {
        shiftIds: [...existingShiftIds, shiftId],
      },
    }))
  })